const { isElementInViewport } = require('util/functions');
const { trackGtm } = require('util/functions');
module.exports = {
	init() {
		if (this.root.querySelector('.content-block--close')) {
			this.root
				.querySelector('.content-block--close')
				?.addEventListener('click', this.hideWarning.bind(this));
		}

		if (this.root.dataset.fade) {
			let options = {
				threshold: 0.1,
			};
			isElementInViewport(options, this.root, 'hidden');
		}

		const links = this.root.querySelectorAll('a.cta');

		links.forEach(link => {
			link.addEventListener('click', () => {
				if (link.closest('.content-block')) {
					trackGtm({
						event: 'GA Tracking',
						eventCategory: 'cta',
						eventAction: 'button',
						eventLabel: `${link.textContent} | ${link?.href}`,
					});
				}
			});
		});
	},
	hideWarning() {
		this.root.querySelector('.content-block--warning').style.display = 'none';
	},
};
